import { computed } from 'vue'
import store from '../store'
import i18n from '@/plugins/i18n'

const licenses = computed(() => store.getters['license/licenses'] ?? [])
const licencesPermissions = computed(() => store.getters['license/getLicencesPermissions'] ?? [])
export const licenseModules = {
    // CONTACT_WEB : 'contact_web',
    // TAX_WEB : 'taxe_web',
    // POS_WEB: 'pos_web',
    // STAT_SALES_WEB: 'stat_sales_web',
    // STAT_CATEGORIES_WEB: 'stat_categories_web',
    // STAT_CUSTOMERS_WEB: 'stat_customers_web',
    // WAREHOUSES: 'warehouses',
    // REGISTER_CASH_WEB: 'register_cash_web',
    // SHOP_ENTRY_WEB: 'shop_entry_web',
    // SHOP_TRANSFER_WEB: 'shop_transfer_web',
    // POST_OFFICE_WEB : 'post_office_web',
    // ATTRIBUT_WEB : 'attribut_web',
    // BRAND_WEB : 'brand_web',
    // CATEGORY_WEB : 'category_web',
    // REASON_WEB : 'reason_web',
    // PRODUCT_WEB : 'product_web',
    // LOT_WEB : 'lot_web',
    // VARIATION_WEB : 'variation_web',
    // PAYMENT_TYPE_WEB : 'payment_type_web',
    // NORMALIZATION_WEB : 'normalization_web',
    // WAREHOUSES_TRANSFER_WEB : 'warehouses_transfer_web',
    // WAREHOUSES_ENTRY_WEB : 'warehouses_entry_web',


    CONTACT_WEB : 'contact_view',
    TAX_WEB : 'taxe_view',
    POS_WEB: 'can_sale_product',
    POS_SESSION_WEB: 'sales_session_view',
    STAT_SALES_WEB: 'stat_sales_web',
    STAT_CATEGORIES_WEB: 'stat_categories_web',
    STAT_CUSTOMERS_WEB: 'stat_customers_web',
    WAREHOUSES: 'magasin_view',
    REGISTER_CASH_WEB: 'shop_cash_box_view',
    SHOP_ENTRY_WEB: 'entry_shop_view',
    SHOP_TRANSFER_WEB: 'transfer_shop_view',
    POST_OFFICE_WEB : 'post_office_view',
    ATTRIBUT_WEB : 'attribut_view',
    BRAND_WEB : 'brand_view',
    CATEGORY_WEB : 'category_view',
    REASON_WEB : 'reason_view',
    PRODUCT_WEB : 'product_view',
    LOT_WEB : 'lot_view',
    BUNDLE_WEB: 'product_view',
    VARIATION_WEB : 'variation_view',
    PAYMENT_TYPE_WEB : 'payment_type_view',
    NORMALIZATION_WEB : 'normalized_key_view',
    WAREHOUSES_TRANSFER_WEB : 'warehouses_transfer_web',
    WAREHOUSES_ENTRY_WEB : 'entry_stock_view',
    STOCK_STATUS_WEB: 'can_view_stock_status',
    CATEGORY_MOBILE : 'category_mobile',
    PRODUCT_MOBILE : 'product_mobile',
    NORMALIZATION_MOBILE : 'normalization_mobile',
    INVOICE_MOBILE : 'invoice_mobile',
    SYNC_MOBILE : 'sync_mobile',

}

export function useLicense() {
    function getLicenseFeatures() {
        const allFeatures = new Set()

        for (const lic of licenses.value) {
            if (!lic?.is_active) continue

            const sources = [
                lic?.permission?.permissions,
                lic?.permissions,
                lic?.resolved_permissions,
                lic?.features,
            ]

            const features = sources.find(Array.isArray)
            if (features) {
                features
                    .filter(f => typeof f === 'string' && f !== '')
                    .forEach(f => allFeatures.add(f))
            }
        }

        return [...allFeatures]
    }

    function hasLicense(featureName = null) {
        const hasActive = licenses.value.some(l => l?.is_active)

        if (!hasActive) {
            return false
        }

        if (!featureName) {
            return true
        }

        return getLicenseFeatures().includes(featureName)
    }

    function showLicensePrompt() {
        Swal.fire({
            title: i18n.global.t('license.required_title'),
            text: i18n.global.t('license.required_text'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: i18n.global.t('license.add_license'),
            cancelButtonText: i18n.global.t('license.cancel'),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-secondary'
            }
        }).then((result) => {
            if(result.isConfirmed){
                $('#licenseActivationModal').modal('show')
            }
        })
    }

    return { hasLicense, showLicensePrompt }
}
